import API from 'API/index'
import {enqueueSnackbar as enqueueSnackbarAction} from 'store/actions/notifier'
import * as typeNotifier from 'shared/typeNotifications'
import * as informationMessages from 'constants/infoMessages'

export const START_LOAD_UNBALANCE_CHARTS = 'START_LOAD_UNBALANCE_CHARTS'
export const SUCCESS_LOAD_UNBALANCE_CHARTS = 'LOAD_UNBALANCE_CHARTS'
export const ERROR_LOAD_UNBALANCE_CHARTS = 'ERROR_LOAD_UNBALANCE_CHARTS'
export const DATE_PRESET_CHANGE_UNBALANCE_CHARTS = 'DATE_PRESET_CHANGE_UNBALANCE_CHARTS'
export const DRP_CHANGE_UNBALANCE_CHARTS = 'DRP_CHANGE_UNBALANCE_CHARTS'
export const SUCCESS_LOAD_MIN_MAX_DATE_UNBALANCE_CHARTS =
  'SUCCESS_LOAD_MIN_MAX_DATE_UNBALANCE_CHARTS'

export const loadChartsUnbalance = (typeChart, id, dateRange, t) => dispatch => {
  dispatch({type: START_LOAD_UNBALANCE_CHARTS})
  API.getChartsUnbalance(typeChart, id, dateRange)
    .then(({data}) => {
      dispatch({
        type: SUCCESS_LOAD_UNBALANCE_CHARTS,
        data,
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_LOAD_UNBALANCE_CHARTS,
      })
      dispatch(
        enqueueSnackbarAction({
          message: t(`infoMessages:${informationMessages.DATA_LOADING_ERROR}`),
          options: {
            variant: typeNotifier.ERROR,
          },
        }),
      )
      console.error('LOAD_ALL_CHARTS')
    })
}
